module.exports = __webpack_public_path__ + "img/logoMetodoPhD.171ea17c.jpeg";